import React from 'react';
import PropTypes from 'prop-types';

import { TableWrapper } from './css';
import TableHeader from './tableHeader';
import TableBody from './tableBody';
import Pagination from './pagination';

const Table = ({
  title,
  headers,
  data,
  actions,
  dataModel,
  currentPage,
  step,
  totalRecords,
  url
}) => {
  // @Todo Sorting need to be done on backend side first
  // const [sort, setSort] = useState(defaultSort);
  // const { index, dir } = sort;
  // const sortIcon = dir ? '↑' : '↓';
  // const onClick = indexNew => {
  //   const sortNew = { index: indexNew };
  //   sortNew.dir = index === indexNew ? !dir : true;
  //   setSort(sortNew);
  // };
  const keys = Object.keys(headers);

  return (
    <>
      <TableWrapper>
        <TableHeader
          heading={`${title} (${totalRecords})`}
          keys={keys}
          data={headers}
          // onClick={onClick}
          // sortIndex={index}
          // sortIcon={sortIcon}
        />
        <TableBody
          keys={keys}
          data={data}
          actions={actions}
          dataModel={dataModel}
          currentPage={currentPage}
          step={step}
        />
      </TableWrapper>
      <Pagination
        currentPage={currentPage}
        step={step}
        totalRecords={totalRecords}
        url={url}
      />
    </>
  );
};

Table.propTypes = {
  title: PropTypes.string.isRequired,
  headers: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.func,
  defaultSort: PropTypes.shape({
    index: PropTypes.string,
    dir: PropTypes.bool
  }),
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentPage: PropTypes.number,
  step: PropTypes.number,
  totalRecords: PropTypes.number.isRequired,
  url: PropTypes.string
};

Table.defaultProps = {
  defaultSort: {
    index: 'first_name',
    dir: false
  },
  dataModel: {},
  currentPage: 1,
  step: 50,
  url: '',
  actions: () => {}
};

export default Table;
